import { render, staticRenderFns } from "./pointBucket.vue?vue&type=template&id=25a9c523&"
import script from "./pointBucket.vue?vue&type=script&lang=js&"
export * from "./pointBucket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports